
import { MessageBaseDto } from '@/__generated__/globalTypes'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MessageThread extends Vue {
  @Prop({ required: true }) messages!: MessageBaseDto[]

  get language() {
    return this.$i18n.locale
  }

  getMessageDateAndSender(msg: MessageBaseDto) {
    return `[${new Date(Date.parse(msg.dateCreated)).toLocaleDateString(this.language, {
      dateStyle: 'full'
    })}] ${msg.sender}:`
  }
}
